import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import Select from 'react-select';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';

const PER_PAGE = 20;

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // テンプレート
  const [operationHistories, setOperationHistories] = useState([]);
  const [searchFromAt, setSearchFromAt] = useState("");
  const [searchToAt, setSearchToAt] = useState("");
  const [searchScreens, setSearchScreens] = useState([]);
  const [searchOperations, setSearchOperations] = useState([]);
  const [searchUsers, setSearchUsers] = useState(props.default_search_ids);
  const [isLoading, setIsLoading]  = useState<Boolean>(true);
  const [startCount, setStartCount] = useState(0);
  const [endCount, setEndCount] = useState(startCount + PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);


  useEffect(() =>{
    searchOperationHistories();
  }, [])

  // 開始位置がかわったとき
  useEffect(() =>{
    setEndCount(startCount + PER_PAGE);
  }, [startCount])

  function searchOperationHistories(){
    setIsLoading(true);
    setStartCount(0);
    setCurrentPage(0);
    axios.get(
      '/api/internal/operation_histories/search_operation_histories', { params: 
        { search_screens: searchScreens, 
          search_operations: searchOperations, 
          search_from_at: searchFromAt, 
          search_to_at: searchToAt,
          search_m_user_ids: searchUsers
        }})
      .then(function (response) {
        setOperationHistories(response.data.d_operation_histories);
        setIsLoading(false);
      })
      .catch(error => {
        alert(error.response.data.message)
        setIsLoading(false);
      }
    ); 
  }

  const onChangeSearchScreens = (values) => {
    setSearchScreens(values.map(value => value["value"]))
  }

  const onChangeSearchOperations = (values) => {
    setSearchOperations(values.map(value => value["value"]));
  }

  const onChangeUsers = (values) => {
    setSearchUsers(values.map(value => value["value"]));
  }

  const onChangePage = (value) => {
    setStartCount(value['selected'] * PER_PAGE);
    setCurrentPage(value['selected'])
  }



  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      <h3>操作履歴</h3>
      <br/>
      {/* 検索エリア */}
      <div id="patient_search_area" className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
        <div className="panel-body">
          {/* 操作日付 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-12">
                <label className="control-label">操作日付</label>
              </div>
              <div className="form-inline col-md-12">
                <div className="pos_relative pull-left">
                  <input type="datetime-local" step="1" className="form-control m5" placeholder="出力日時(from)" onChange={(e) => setSearchFromAt(e.target.value)}/>
                </div>
                <div className="pos_relative pull-left m5">〜</div>
                <div className="pos_relative pull-left">
                  <input type="datetime-local" step="1" className="form-control m5" placeholder="出力日時(to)" onChange={(e) => setSearchToAt(e.target.value)}/>
                </div>
              </div>
            </div>
          </div>

          {/* 操作画面 */}
          <div className="row">
            <div className="form-group col-md-7">
              <div className="col-md-12">
                <label>操作画面名</label>
              </div>
              <div className="col-md-12">
                <Select
                  isMulti
                  onChange={onChangeSearchScreens}
                  options={props.screens}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="選択してください"
                />
              </div>
            </div>
          </div>

          {/* 操作内容 */}
          <div className="row">
            <div className="form-group col-md-5">
              <div className="col-md-12">
                <label>操作内容</label>
              </div>
              <div className="col-md-12">
                <Select
                  isMulti
                  onChange={onChangeSearchOperations}
                  options={props.operations}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="選択してください"
                />
              </div>
            </div>
          </div>

          {/* ユーザー名 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-12">
                <label>操作ユーザー</label>
              </div>
              <div className="col-md-12">
                <Select
                  isMulti
                  onChange={onChangeUsers}
                  options={props.m_users}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="選択してください"
                  defaultValue={props.default_search_m_users}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-12 mt10 text-right">
              <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary" data-disable-with="検索" onClick={() => searchOperationHistories()}/>
            </div>
          </div>
        </div>
      </div>
        
        {/* 表示エリア */}
        <div className="table-responsive">
          <table id="notice_table" className="table table-bordered">
            <thead>
            <tr className="success">
              <th scope="col" className="text-center col-md-3">操作日付</th>
              <th scope="col" className="text-center col-md-9">メッセージ</th>
            </tr>
            </thead>
            <tbody>
              { operationHistories.slice(startCount, endCount).map((operation_History) =>
                { 
                  return(
                    <>
                      <tr>
                        <td>{operation_History.view_created_at}</td>
                        <td>{operation_History.message}</td>
                      </tr>
                    </>
                  )
                }
            )}
            </tbody>
          </table>
          <div className="text-center">
            <ReactPaginate
              pageCount={Math.ceil(operationHistories.length / PER_PAGE)} 
              marginPagesDisplayed={1}
              pageRangeDisplayed={5} 
              onPageChange={onChangePage} 
              containerClassName='pagination'
              pageClassName='page-item'
              pageLinkClassName='page-link'
              activeClassName='active'
              previousLabel='前'
              nextLabel='次'
              previousClassName='page-item'
              nextClassName='page-item'
              previousLinkClassName='page-link'
              nextLinkClassName='page-link'
              disabledClassName='disabled'
              breakLabel='...' 
              breakClassName='page-item'
              breakLinkClassName='page-link'
              forcePage={currentPage}
            />
          </div>
        </div>
    </LoadingOverlay>
  )
}
export default Index;